import React from 'react';
import { StyleSheet } from 'react-native';
import { IconButton, SxProps, Theme } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { ColorScheme, theme } from '../../constants/theme';
import pause from '../../asset/images/icons/es_pause.svg';
import CustomLazyLoadImage from '../Image/CustomLazyLoadImage';
// import Play from '../VideoPlayer/NebulaPlayer/PlayIcon';

interface IEsPlayButton {
    onClick?: (...args: any) => void;
    disabled?: boolean;
    sx?: SxProps<Theme>;
}
const EsPlayButton: React.FC<IEsPlayButton> = ({ onClick, disabled, sx }) => {
    const { themeStyle } = useThemeContext();
    const styles = dynamicStyles(themeStyle);

    return (
        <IconButton
            style={styles.background}
            disabled={disabled}
            onClick={onClick}
            sx={{ transform: 'translate(-50%, -50%)', '&:hover': { background: 'none' }, borderRadius: '50%', ...sx }}>
            <CustomLazyLoadImage src={pause} alt="pause button" style={{ width: '45px', height: '45px' }} />
            {/* <Play fill={theme[themeStyle].highlight} style={{ width: '50px', height: '50px' }} /> */}
        </IconButton>
    );
};

const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        background: {
            width: 'fit-content',
            height: 'fit-content',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            top: '50%',
            left: '50%',
            backgroundColor: theme[colorScheme].darkGray60,
        },
    });

export { EsPlayButton };
